import { render, staticRenderFns } from "./StatisticsCentre.vue?vue&type=template&id=165794ae"
import script from "./StatisticsCentre.vue?vue&type=script&lang=js"
export * from "./StatisticsCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports